const i = { step: "Qadam {{current}} dan {{max}}. {{name}}", title: { first: "Sizning avtomobilingiz", second: "Sizning avtomobilingiz", third: "Avtomobil parametrlari", fourth: "Avtomobil parametrlari", success: "Narx hisob-kitobi" } }, a = { title: "Afsuski, hisob-kitobni o'tkazishning uddasidan chiqilmadi", description: "Afsuski, biz siz tanlagan barcha mezonlarga mos keladigan natijalarni topa olmadik. Ba'zi parametrlarni o'zgartirishga urinib ko'ring.", noEstimate: { title: "Baho yo'q", description: "Noyob, urilgan va yangi mashinalar uchun bozor narxini hisoblab chiqarish mumkin bo'lmaydi." }, startAgain: "Qayta boshlash" }, t = { goTo: "Parametrlarni qo'lda to'ldirish", back: "Orqaga", forward: { default: "Davom ettirish", byStage: { third: "Narxini hisoblab chiqarish", fourth: "Narxini hisoblab chiqarish" } } }, o = { estimatedPrice: { title: "Sotib olishning taxminiy qiymati", noData: "Ma'lumotlar yo'q" }, save: "Natijani saqlash", reset: "Qayta boshlash" }, r = { errors: { required: "To'ldirilishi shart maydon", incorrect: "Noto'g'ri qiymat", emptyListValues: "Qiymatlar ro'yxatini olishning iloji bo'lmadi" } }, s = {
  stageHeader: i,
  errorStage: a,
  stage: t,
  successStage: o,
  field: r
};
export {
  s as default,
  a as errorStage,
  r as field,
  t as stage,
  i as stageHeader,
  o as successStage
};
